import React from 'react';
import PropTypes from 'prop-types';
import {Dropdown} from 'primereact/dropdown';
import {isArray} from 'lodash';

const DaysOfTheWeek = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

const airDayOfWeekPicker = ({onChange, value, id}) => (
    <Dropdown
        filter={false}
        filterBy="label,value"
        filterPlaceholder="Select Day"
        id={id}
        options={
            isArray(DaysOfTheWeek)
                ? DaysOfTheWeek.map(dayOfTheWeek => ({
                      label: dayOfTheWeek,
                      value: dayOfTheWeek.toUpperCase(),
                  }))
                : []
        }
        showClear={false}
        style={{width: '200px'}}
        value={value}
        onChange={onChange}
    />
);

airDayOfWeekPicker.propTypes = {
    id: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired,
};

export default airDayOfWeekPicker;
